import React, { useContext } from 'react';
import "./style.scss"
import { UserContext } from '../../../utils/context/userContext';
import { HeightCalculate } from "../../../utils/helpers"
import { Images } from "../../../utils/Images"
// icons 
import Icon from 'react-icons-kit';
import { ic_check_circle, ic_clear } from 'react-icons-kit/md'
import { heartBroken } from 'react-icons-kit/ionicons/heartBroken'

const Index = ({ data }) => {
    const { user } = useContext(UserContext)
    const partner = data?.partner || {}

    const matchCount = Number(partner.count) || 0
    const matchPercent = Math.min(100, Math.round((matchCount / 7) * 100))

    // Combination Partner Preference ---- cors matching ---
    const preferences = [
        {
            label: 'Age',
            value: `${partner.ageRange?.startFrom || "---"} To ${partner.ageRange?.endTo || "---"}`,
            status: partner.ageStatus
        },
        {
            label: 'Height',
            value: (partner.heightRange?.startFrom || partner.heightRange?.endTo)
                ? `${partner.heightRange?.startFrom
                    ? `${HeightCalculate(partner.heightRange.startFrom)} (${partner.heightRange.startFrom})`
                    : "---"} To ${partner.heightRange?.endTo
                        ? `${HeightCalculate(partner.heightRange.endTo)} (${partner.heightRange.endTo})`
                        : "---"}`
                : "---",
            status: partner.heightStatus
        },
        {
            label: 'Marital Status',
            value: partner.material || "---",
            status: partner.materialStatus
        },
        {
            label: 'Religion / Community',
            value: partner.religion || "---",
            status: partner.religionStatus
        },
        {
            label: 'Mother Tongue',
            value: partner.motherTongue || "---",
            status: partner.motherTongueStatus
        },
        {
            label: 'Country Living In',
            value: partner.country || "---",
            status: partner.countryStatus
        },
        {
            label: 'Qualification',
            value: partner.qualification || "---",
            status: partner.qualificationStatus
        },
    ]

    return (
        <div id="partner_preference">
            <section className="info_box">
                <h5 className="details_title">
                    <Icon icon={heartBroken} size={22} />
                    What {data?.gender === 'male' ? 'he' : data?.gender === 'female' ? 'she' : "he/she"} is looking for
                </h5>

                {/* 2-way match */}
                <div className="match_head">
                    <div className="person">
                        <img src={data?.images?.[0]?.name || Images.Avatar} alt={data?.name || "Profile"} />
                        <span>{data?.name || "Profile"}</span>
                    </div>

                    <div className="match_score">
                        <div className="score">
                            <strong>{matchCount}</strong>
                            <span>/ 7</span>
                        </div>
                        <div className="progress">
                            <div
                                className="progress-bar"
                                role="progressbar"
                                style={{ width: matchPercent + "%" }}
                                aria-valuenow={matchPercent}
                                aria-valuemin="0"
                                aria-valuemax="100"
                            />
                        </div>
                        <p>2-way Match</p>
                    </div>

                    <div className="person">
                        <img src={user?.profilePicture?.clearImage || Images.Avatar} alt="You" />
                        <span>You</span>
                    </div>
                </div>

                {/* Preferences */}
                <div className="preference_list">
                    {preferences.map((item, i) => (
                        <div className="preference_row" key={i}>
                            <div className="row_label">{item.label}</div>
                            <div className="row_value">{item.value}</div>
                            <div className={item.status ? "status active" : "status"}>
                                <Icon icon={item.status ? ic_check_circle : ic_clear} size={18} />
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default Index;
